import type { TFunction } from 'i18next';
import type { IFolder } from '@apis/documents';

/**
 * Display name for a folder. Root folders (parentId null, id like "photo:/")
 * carry Genba's Japanese rootName — relabel them by root key, falling back to
 * the upstream name via i18n's defaultValue. Non-roots keep their own name.
 */
export function folderDisplayName(t: TFunction, folder: IFolder): string {
  return folder.parentId === null
    ? t(`documents.roots.${folder.id.split(':')[0]}`, { defaultValue: folder.name })
    : folder.name;
}
